// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button[data-v-fd172e7a]{margin-bottom:10px}`, "",{"version":3,"sources":["<input css 11>"],"names":[],"mappings":"AAAA,yBAAQ,kBAAkB","sourcesContent":[".button{margin-bottom:10px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
